module.exports = __webpack_public_path__ + "img/d9a38dc089b279491d4621ad45c523b8.png";